import { render, staticRenderFns } from "./details_distribution.vue?vue&type=template&id=5e62f7fb&scoped=true&"
import script from "./details_distribution.vue?vue&type=script&lang=js&"
export * from "./details_distribution.vue?vue&type=script&lang=js&"
import style0 from "./details_distribution.vue?vue&type=style&index=0&id=5e62f7fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e62f7fb",
  null
  
)

export default component.exports